import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "layout-login__state-desc"
}
const _hoisted_2 = { class: "layout-login__wrap-input" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "layout-login__desc-input" }, "Восстановление доступа", -1)
const _hoisted_4 = { class: "layout-login__input-addons" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

import AuthLayout from "@/layouts/AuthLayout.vue";
import { UserIcon, ArrowLeftIcon } from "tir-style-system/icons/outline";
import { TirPmInput } from "tir-pm-input";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-pm-button";
import { TirDivider } from "tir-pm-divider";
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";

import ApiService from "@/shared/api";
import { EmailValidation } from "@/tir-pm-validation";


export default /*#__PURE__*/_defineComponent({
  __name: 'RestoreAccessPage',
  setup(__props, { expose: __expose }) {

onMounted(() => {});

const login = ref("");

const router = useRouter();

const showError = ref(false);
const errorMessage = ref("");

/**
 * Лоадер для кнопки
 */
const loadingRequest = ref(false);

/**
 * Перерасчет высоты
 */
const loadingRequestComputed = computed(() => {
  return loadingRequest.value;
});

const api = new ApiService();

const onInput = () => {
  showError.value = false;
  updateHeight();
};

const updateHeight = () => {
  setTimeout(() => {
    currentHeightComponent.value = $currentComponentWrapper.value?.offsetHeight;
    console.log(currentHeightComponent.value);
  });
};

const onRestoreAccess = () => {
  loadingRequest.value = true
  let testEmail = EmailValidation(login.value);
  if (testEmail.IsSuccess) {
    api.Main.UsersService.resetPasswordGetTokenAsync({ Email: login.value })
      .then((data) => {
        if (data.ErrorMessage) {
          console.log(data.ErrorMessage);
          showError.value = true;
          errorMessage.value = data.ErrorMessage;
        } else {
          router.push(`/restore-done/${login.value}`);
          showError.value = false;
        }
      })
      .catch((err) => {
        showError.value = true;
        errorMessage.value = err.ErrorMessage;
      });
  } else {
    showError.value = true;
    errorMessage.value = testEmail.Message;
  }
  loadingRequest.value = false
  updateHeight();
};

const $currentComponentWrapper = ref(null);
const currentHeightComponent = ref(0);

const currentHeightLocalComputed = computed(() => {
  return currentHeightComponent.value;
});

onMounted(() => {
  currentHeightComponent.value = $currentComponentWrapper.value?.offsetHeight;
});

__expose({
  changerMethodFromComponent: onRestoreAccess,
  currentHeightComponent: currentHeightLocalComputed,
  isLoadingIntoComponent: loadingRequestComputed,
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: "layout-login__body",
    ref_key: "$currentComponentWrapper",
    ref: $currentComponentWrapper
  }, [
    _createVNode(_component_RouterLink, {
      to: "/login",
      class: "layout-login__back-link"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ArrowLeftIcon)),
        _createTextVNode(" Назад ")
      ]),
      _: 1
    }),
    (_ctx.$route.path == '/restore-success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Восстановление доступа "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(TirPmInput), {
        type: "email",
        isAutocomplete: "",
        label: "Электронная почта",
        placeholder: "",
        onInput: onInput,
        "is-show-hint": "",
        modelValue: login.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((login).value = $event)),
        isWithError: showError.value
      }, {
        leftInputAddons: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(UserIcon))
          ])
        ]),
        hintMessage: _withCtx(() => [
          (!showError.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Введите ваш адрес электронной почты, который был указан при авторизации"))
            : _createCommentVNode("", true),
          (showError.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "isWithError"])
    ])
  ], 512))
}
}

})